import { useState, useEffect, useRef } from "react";

import Modal from "react-bootstrap/Modal";

import { api, cleanAIAnswer, parseArray, robustJsonParse, speakGerman } from "../pureFunctions";
import { Button, Form, Col, Alert, Row, Spinner, Table, ButtonGroup } from "react-bootstrap";
import { header } from "../globalVariables";

import aiIcon from "../img/ki.png";
import editIcon from "../img/edit.png";

import { milieuForm, milieuOutputConfig, milieuPrompt, milieuTexte } from "./MilieuData";
import TextMitZeilennummern from "../Zeilennummern";
import NummerierteSaetze from "../NummerierteSaetze";
import { formatText } from "../formatFunctions";
import { useContextMenu, ContextMenu, getItemsForContext } from "../Utils/ContextMenu";
import MyProgressBar from "../Tools/MyProgressBar";
import { SpinnerGroup } from "../Utils/SpinnerGroup";
import { debouncedSaveEstateData, saveEstateData } from "../networkFunctions";
import LoadingAnimation from "../LoadingAnimation";

export default function AIExpoPlaces({
   estateId,
   placesData,
   setPlacesData,
   user,
   getGooglePlaces,
   ignoreLevel,
   importantLevel,
}) {
   function changePlacesData(katIndex, objIndex, importance) {
      let updatedPlacesData = structuredClone(placesData);
      updatedPlacesData[katIndex].objekte[objIndex]["importance"] = importance;
      console.log(updatedPlacesData);

      setPlacesData(updatedPlacesData);
      debouncedSaveEstateData({ places: updatedPlacesData }, estateId);
   }

   return (
      <>
         <Button
            className="my-2 w-100"
            variant={placesData ? "outline-dark" : "primary"}
            onClick={async () => {
               const googleData = await getGooglePlaces();
               console.log(googleData);
               setPlacesData(googleData);
            }}
         >
            Lagedaten {placesData ? "neu laden" : "laden"}
         </Button>
         <div
            style={{
               maxHeight: "70vh",
               overflow: "auto",
               scrollbarColor: "#ccc transparent",
               scrollbarWidth: "thin",
            }}
         >
            <Form className="mx-0" style={{ width: "calc( 100% - 20px)" }}>
               {placesData?.map((kat, katIndex) => {
                  return (
                     <Row key={kat.key ?? katIndex}>
                        <Col md={12} sm={12}>
                           <Form.Group
                              controlId={"placeitem_" + katIndex}
                              className="mb-2 mt-2"
                              style={{
                                 padding: "20px",
                                 boxShadow: "inset 0 0 8px #ccc",
                                 borderRadius: "20px",
                              }}
                           >
                              <Form.Label>{kat.label}:</Form.Label>
                              <ButtonGroup
                                 className="w-100 "
                                 vertical
                                 style={{ /* boxShadow: "0 0 6px #0003", */ borderRadius: "10px" }}
                              >
                                 {kat.objekte.map((obj, objIndex) => (
                                    <div className="flex-row w-100" key={`${kat.key}-${objIndex}h`}>
                                       <div
                                          className="w-75"
                                          style={{
                                             ...(obj.importance === ignoreLevel
                                                ? { textDecoration: "line-through" }
                                                : {}),
                                             opacity: obj.importance === importantLevel ? 1 : 0.7,
                                          }}
                                       >
                                          <strong title={obj.name}>{obj.name}</strong>
                                          <small className="mx-1" title={obj.typ}>
                                             ({obj.typ})
                                          </small>
                                          <span className="mx-1">Distanz: {obj.distanz}m</span>
                                          {obj.bewertung && (
                                             <span className="mx-1">
                                                <strong>{obj.bewertung}⭐</strong>
                                                <small className="">({obj.anzahlBewertungen})</small>
                                             </span>
                                          )}
                                       </div>
                                       <Button
                                          variant={obj.importance === importantLevel ? "dark" : "outline-dark"}
                                          onClick={() => {
                                             changePlacesData(
                                                katIndex,
                                                objIndex,
                                                obj.importance === importantLevel ? 3 : importantLevel,
                                             );
                                          }}
                                       >
                                          Hervorheben
                                       </Button>
                                       <Button
                                          variant={obj.importance === ignoreLevel ? "dark" : "outline-dark"}
                                          className={"ms-1 text-start "}
                                          onClick={() => {
                                             changePlacesData(
                                                katIndex,
                                                objIndex,
                                                obj.importance === ignoreLevel ? 3 : ignoreLevel,
                                             );
                                          }}
                                       >
                                          Ignorieren
                                       </Button>
                                    </div>
                                 ))}
                              </ButtonGroup>
                           </Form.Group>
                        </Col>
                     </Row>
                  );
               })}
            </Form>
         </div>
      </>
   );
}
